import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import {Translate} from "react-localize-redux";

class SidebarMenu extends Component {
    render() {
        return (
            <Translate>
                {({translate}) => (
                    <div className="sidebar-menu-wrapper">
                        <NavLink to="/profile/settings" className="icon-profile-settings" activeClassName="selected">{translate("PROFILE_SETTING")}</NavLink>
                        <NavLink to="/profile/language" className="icon-lang" activeClassName="selected">{translate("LANGUAGE")}</NavLink>
                        <NavLink to="/profile/change-password" className="icon-password"  activeClassName="selected">{translate("CHANGE_PASSWORD")}</NavLink>
                        <NavLink to="/profile/inbox" className="icon-message"  activeClassName="selected">{translate("INBOX")}</NavLink>
                        <NavLink to="/profile/deposit" className="icon-deposit"  activeClassName="selected">{translate("DEPOSIT")}</NavLink>
                        <NavLink to="/profile/documents" className="icon-doc"  activeClassName="selected">{translate("DOCUMENTS")}</NavLink>
                        <NavLink to="/profile/withdraw" className="icon-witdraw" activeClassName="selected">{translate("WITHDRAW")}</NavLink>
                        <NavLink to="/profile/history" className="icon-history"  activeClassName="selected">{translate("HISTORY")}</NavLink>
                        <NavLink to="/profile/bonuses" className="icon-bonus" activeClassName="selected">{translate("BONUSES")}</NavLink>
                        {/*<NavLink to="/profile/change-email" activeClassName="selected">{translate("CHANGE_MAIL")}</NavLink>
                        <NavLink to="/profile/todo" activeClassName="selected">{translate("WITHDRAW")}</NavLink>
                        <NavLink to="/profile/security" activeClassName="selected">{translate("SECURITY")}</NavLink>
                        <NavLink to="/profile/todo" activeClassName="selected">{translate("PROMOTIONS")}</NavLink>*/}
                    </div>
                )}
            </Translate>
        )
    }
}

export default SidebarMenu;